import { ArrowUpRight, Globe, Shield } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { desktop } from "./bridge";

/** Endereço da administração na plataforma web (o app carrega a interface do mesmo servidor). */
export const adminWebUrl = () => `${location.origin}/admin`;

/** Abre a administração no navegador do sistema. */
export function openAdminInBrowser() {
  desktop?.openExternal(adminWebUrl());
}

/**
 * Administração do Kompil (ADR 0026): só na plataforma web. No app desktop, a rota mostra o aviso
 * e o caminho para o navegador; a API também recusa sessões do app nessas áreas.
 */
export function WebOnlyAdmin({ children }: { children: ReactNode }) {
  if (!desktop) return <>{children}</>;
  return (
    <div className="mx-auto max-w-2xl animate-fade-up py-10">
      <div className="surface relative overflow-hidden rounded-2xl border border-border p-8">
        <div aria-hidden className="bg-halo pointer-events-none absolute inset-0 opacity-60" />
        <div className="relative">
          <span className="surface inline-flex h-12 w-12 items-center justify-center rounded-xl border border-border-strong">
            <Shield className="h-5 w-5" />
          </span>
          <p className="label-mono mt-5">Plataforma web</p>
          <h1 className="mt-1 text-2xl font-semibold tracking-tight">A administração fica na web</h1>
          <p className="mt-2 max-w-xl text-[14px] text-fg-muted">
            Por segurança, o painel da plataforma, a moderação, os logs e o envio de atualizações do app abrem
            só no navegador, numa sessão separada da IDE.
          </p>
          <Button variant="primary" className="mt-6" onClick={openAdminInBrowser}>
            <Globe className="h-4 w-4" /> Abrir no navegador{" "}
            <ArrowUpRight className="h-3.5 w-3.5 opacity-70" />
          </Button>
        </div>
      </div>
    </div>
  );
}
